import React from 'react';
import style from './style.less';

interface IProps{
    onClick?: () => void;
    type: 'error' | 'success';
    title: string;
    text: string;
}
const QRCodeMask = (props: IProps) => {
    const { onClick, type, title, text } = props;
    return (
        <div className={style['mask-container']} onClick={onClick}>
            <span className={style['mask-bg']}></span>
            <div className={style['mask-info']}>
                <span className={`${style['mask-icon']} ${style[type]}`}></span>
                <span className={style['mask-title']}>{title}</span>
                <span className={style['mask-text']}>{text}</span>
            </div>
        </div>
    );
};

export default QRCodeMask;
